var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-charger"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "charger",
    clipPath: "url(#clip-charger)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "charger-2",
    "data-name": "charger",
    transform: "translate(23 -7.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(68.267 125.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M281.6,123.733H76.8c-5.12,0-8.533,3.413-8.533,8.533v102.4c0,5.12,3.413,8.533,8.533,8.533H281.6c5.12,0,8.533-3.413,8.533-8.533v-102.4A8.551,8.551,0,0,0,281.6,123.733Z",
    transform: "translate(-68.267 -123.733)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 29.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M440.7,169.24v-9.523c0-9.523-6.958-17.314-15.463-17.314H409.769V125.09c0-5.194-3.092-8.656-7.731-8.656H316.991V79.211c4.639-2.6,7.731-8.656,7.731-14.717V47.18c0-9.523-6.958-17.314-15.463-17.314H15.463C6.958,29.867,0,37.658,0,47.18V64.494c0,6.059,3.092,12.12,7.731,14.717V289.57c0,9.523,6.958,17.314,15.463,17.314H54.12v77.911c0,14.717,10.051,25.97,23.195,25.97h7.731v34.627c0,19.045,13.917,34.627,30.926,34.627S146.9,464.436,146.9,445.391V410.765h30.926v34.627c0,19.045,13.917,34.627,30.926,34.627s30.926-15.582,30.926-34.627V410.765h7.731c13.144,0,23.195-11.253,23.195-25.97V306.884h30.928c8.5,0,15.463-7.791,15.463-17.314V237.629h85.047c4.639,0,7.731-3.462,7.731-8.656V211.659h15.463c8.5,0,15.463-7.791,15.463-17.314v-6.059c4.639,2.6,7.731,8.656,7.731,14.717V436.735c0,19.045-13.917,34.627-30.926,34.627-14.69,0-26.287-11.253-30.153-25.97h3.092c6.185,0,11.6-6.059,11.6-12.985V409.033a15.676,15.676,0,0,0,7.731-13.85v-6.06c0-2.6,1.547-4.329,3.866-4.329,10.824,0,19.328-9.523,19.328-21.642V315.54c0-10.388-6.185-17.314-15.463-17.314v-25.97c0-5.194-3.092-8.656-7.731-8.656H347.918c-4.639,0-7.731,3.462-7.731,8.656v25.97c-9.278,0-15.463,6.926-15.463,17.314v47.612c0,12.12,8.5,21.642,19.328,21.642,2.319,0,3.866,1.732,3.866,4.329v6.059a15.675,15.675,0,0,0,7.731,13.85v23.373c0,6.926,5.412,12.985,11.6,12.985h4.639c3.866,24.239,22.422,43.284,45.616,43.284,25.514,0,46.389-23.373,46.389-51.941V203C463.89,186.554,453.84,173.569,440.7,169.24ZM255.14,384.793c0,5.194-3.092,8.656-7.731,8.656H77.315c-4.639,0-7.731-3.462-7.731-8.656V306.882H255.14Zm23.195-147.164c0,14.717-10.051,25.97-23.195,25.97H69.584c-13.144,0-23.195-11.253-23.195-25.97V133.748c0-14.717,10.051-25.97,23.195-25.97H255.14c13.144,0,23.195,11.253,23.195,25.97ZM309.26,64.494H15.463V47.18h293.8V64.494ZM425.233,177.031v17.314H409.769V159.718h15.463ZM355.649,298.226V280.912h46.389v17.314Zm30.927,129.851H371.112V410.764h15.463Z",
    transform: "translate(0 -29.866)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharger);
export default __webpack_public_path__ + "static/media/charger.614e7058c7dc9c7d822278ec2bad8876.svg";
export { ForwardRef as ReactComponent };